package br.com.texeratx.boardgametimeapp.ui.screens.players

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEvent
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEventBus
import br.com.texeratx.boardgametimeapp.ui.screens.players.detail.PlayerDetailScreen
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject

class PlayersScreen : Screen {

    @Composable
    override fun Content() {
        val viewModel = koinInject<PlayersViewModel>()
        val state by viewModel.state.collectAsState()

        val navigator = LocalNavigator.currentOrThrow

        LaunchedEffect(Unit) {
            viewModel.loadPlayers()
        }

        LaunchedEffect(Unit) {
            AppUiEventBus.events.collect { event ->
                if (event is AppUiEvent.PlayerDeleted) {
                    viewModel.loadPlayers()
                }
            }
        }

        PlayersUI(
            state = state,
            onSortChange = viewModel::changeSort,
            onDismissError = viewModel::dismissError,
            onSearch = viewModel::onSearch,
            onApplyFilters = viewModel::updateFilters,
            onBack = { navigator.pop() },
            onPlayerClick = { playerId ->
                navigator.push(PlayerDetailScreen(playerId))
            }
        )
    }

}
